<script>
    import Button from "../shared/Button.svelte";
    import AuthCard from "../shared/AuthCard.svelte";
    import Label from "../shared/Label.svelte";
    import Input from "../shared/Input.svelte";
    import {onMount} from "svelte";
    import {translations} from "../../../stores/translations";
    import {AuthResource} from "../../../Api/resources/AuthResource";

    const authResource = new AuthResource();

    export let currentRoute
    let email;
    let password;
    let confirmPassword;
    let token;
	let isRedirecting = false;

    onMount(() => {
        email = currentRoute.queryParams.email;
        token = currentRoute.namedParams.token;
    });

    function resetPassword() {
		if(isRedirecting){
			return;
		}

		isRedirecting = true;
        authResource.resetPassword(email, password, confirmPassword, token)
            .then(response => {
                alert(response.data.status);
                window.location.href = '/';
            }).catch(error => {
			isRedirecting = false;
            alert(error.response.data.message);
        });
    }
</script>

<AuthCard>
	<form on:submit|preventDefault={resetPassword}>
		<!-- Email Address -->
		<div>
			<Label name="email">{$translations.login_email}</Label>

			<Input id="email"
				   class="block mt-1 w-full"
				   type="email"
				   name="email"
				   required
				   autofocus
				   bind:value={email}
			/>
		</div>

		<!-- Password -->
		<div class="mt-5">
			<Label name="password">{$translations.profile_type_new_pwd}</Label>

			<Input id="password"
				   class="block mt-1 w-full"
				   type="password"
				   name="password"
				   autocomplete="off"
				   required
				   bind:value={password}
			/>
		</div>

		<!-- Confirm Password -->
		<div class="mt-5">
			<Label name="password_confirmation">{$translations.profile_retype_pwd}</Label>

			<Input id="password_confirmation"
				   class="block mt-1 w-full"
				   type="password"
				   name="password_confirmation"
				   required
				   bind:value={confirmPassword}
			/>
		</div>

		<div class="flex items-center justify-end mt-16">
			<Button class="relative" type="submit" on:click={resetPassword} disabled={isRedirecting}>
				<img alt="" class="spinner w-5 h-5 absolute left-2" class:opacity-0={!isRedirecting}
					 src="/{$translations.login_preloader}">
				{$translations.profile_pw_change}
			</Button>
		</div>
	</form>
</AuthCard>
